<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<mat-dialog-content>
    <form [formGroup]="latlonForm">
        <div
            fxLayout="row" fxLayoutAlign="space-between start">
            <mat-form-field class="latlon">
                <input type="text"
                       formControlName="latlonString"
                       matInput placeholder="Lat/Lon" />
            </mat-form-field>
            <button mat-icon-button matTooltip="Go"
                    (click)="zoomToLatLon()" [disabled]="!latlonForm.valid">
                <mat-icon svgIcon="check"></mat-icon>
            </button>
            <button mat-icon-button
                    matTooltip="Close"
                    (click)="closeDialog()">
                <mat-icon svgIcon="close"></mat-icon>
            </button>
        </div>
    </form>
</mat-dialog-content>